import { Component } from 'react'
import { extendObservable, transaction } from 'mobx'
import { observer } from 'mobx-react'
import { CSSTransitionGroup } from 'react-transition-group'

import * as h from 'h'

import { shortcodes, groupBy } from 'utils'

import Panel from './Panel'

import styles from './styles-panel.scss'

@observer
export default class StandardPanel extends Component {
  // --------------------------------------------------------------------------
  // Lifecycle
  // --------------------------------------------------------------------------

  componentWillMount () {
    extendObservable(this, {
      hover: null, // current item being hovered
      main: '', // main content
      sections: {} // sections contents by slug
    })
  }

  // ------------------------------------------------------------------------
  // Helpers
  // ------------------------------------------------------------------------

  // Parsing

  getRawContent (item) {
    const content = window && typeof window.portalMeta !== 'undefined' &&
    window.portalMeta[`landing-${item.slug}`]

    return content || ''
  }

  saveContentParsed (item) {
    const sections = shortcodes(this.getRawContent(item))

    const grouped = groupBy(item.items, ({ slug }) => slug)

    const finalSections = Object.keys(grouped).reduce((acc, k) => {
      const { slug } = grouped[k][0]
      acc[k] = this.getSectionContent(sections, slug)
      return acc
    }, {})

    transaction(() => {
      this.main = this.mergeContentSections(sections)
      this.sections = finalSections
    })
  }

  // Getters

  mergeContentSections (sections) {
    return sections
      .filter(({ type }) => type === 'content')
      .map(({ content }) => content)
      .join('')
  }

  getSectionContent (sections, name) {
    const section = sections
      .filter(s => s.type === 'section' && s.name === name)[0]

    return section && this.mergeContentSections(section.contents)
  }

  // ------------------------------------------------------------------------
  // Lifecycle
  // ------------------------------------------------------------------------

  componentDidMount () {
    this.saveContentParsed(this.props.item)
  }

  componentWillUpdate (nextProps) {
    if (this.props.item !== nextProps.item) {
      this.saveContentParsed(nextProps.item)
    }
  }

  // ------------------------------------------------------------------------
  // Actions
  // ------------------------------------------------------------------------

  onSubItemHover (subItem) {
    if (subItem && subItem.slug && this.sections[subItem.slug]) {
      this.hover = subItem
    }
  }

  onSubItemHoverOut () {
    this.hover = null
  }

  // ------------------------------------------------------------------------
  // Sub-components
  // ------------------------------------------------------------------------

  makeSubItems () {
    const { hover } = this
    const { item } = this.props

    const isExplore = item.slug === 'explore'
    const filterParameter = isExplore ? 'types' : 'subCategories'

    // Make the subItem menu items
    return item.items.map((subItem) => {
      // Keep IP as is, but lowercase anything else
      const nameToLowerCase = subItem.name.toLowerCase()
      const to = subItem.url || `/${item.slug}?${filterParameter}=${subItem.slug}`
      return (
        h.l({
          key: subItem.slug || subItem.url,
          to,
          onMouseEnter: () => ::this.onSubItemHover(subItem),
          ...h.ca({ [styles.smallHover]: hover && hover.slug === subItem.slug })
        }, nameToLowerCase)
      )
    })
  }

  makeMainDisplaySection () {
    return h.raw({ content: this.main })
  }

  makeDisplaySection () {
    const { hover, sections } = this

    const content = hover && sections[hover.slug]
    return h.raw({
      key: hover && hover.slug,
      content
    })
  }

  // --------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------

  render () {
    const { item, onArrowClick } = this.props
    const { slug, name } = item

    const backgroundImage = `url('/landingimage/${slug}'`

    return h.h(Panel, { onArrowClick, ...h.ca(slug), backgroundImage },
      h.div(h.ca(styles.standardContent),
        h.l({ to: '/' + slug, ...h.ca(styles.standardContentTitle) },
          name),
        h.div(h.ca(styles.standardContentAboutMain),
          this.makeMainDisplaySection()),
        h.div({
          onMouseLeave: ::this.onSubItemHoverOut,
          ...h.ca(styles.standardContentSmalls)
        },
          this.makeSubItems()),
        h.div(h.ca(styles.standardContentAbout),
          h.h(CSSTransitionGroup, {
            transitionName: 'standardContentSection',
            transitionEnterTimeout: 100,
            transitionLeave: false
          }, [ this.makeDisplaySection() ]))))
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Landing/StandardPanel.js